var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contact"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }